import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import { DialogContent } from '../components/DialogContent';
import { TextLabel } from '../components/TextLabel';
import { DialogTitle } from '../components/DialogTitle';
import { Progress } from '../components/Progress';
import { timeStampToLongString } from '../utils/stringUtils';
import OrganizationName from '../containers/OrganizationName';
import { isCurrentUserAdmin } from '../utils/userRoles';

export const UserInfoDialog = ({ onClose, onEdit, onDelete, user: { name, email, role, lastLogin, organizationRef }, loading, self }) => (
    <Dialog maxWidth="lg" scroll="body" onClose={onClose} open spacing={0}>
        {isCurrentUserAdmin() ? (
            <DialogTitle onEdit={onEdit} onDelete={onDelete} organizationRef={organizationRef}>
                User: {name}
            </DialogTitle>
        ) : (
            ''
        )}
        <DialogContent>
            {loading && <Progress />}
            <TextLabel label="Name" value={name} />
            <TextLabel label="Email" value={email} />
            <TextLabel label="Role" value={role} />
            <TextLabel label="Last Login" value={lastLogin ? timeStampToLongString(lastLogin) : 'N/A'} />
            <OrganizationName organizationRef={organizationRef} />
        </DialogContent>
    </Dialog>
);
